/**
 * /frontend/src/features/analytics/constants/chartColors.js
 */

/**
 * Centralized chart color palette aligned with the app theme.
 * Uses existing CSS variables (`--trae-*`) so analytics stays in sync.
 */
export const CHART_COLORS = {
  accent: 'var(--trae-accent)',
  accentStrong: 'var(--trae-accent-strong)',
  accentAlt: 'var(--trae-accent-cyan)',
  accentCyan: 'var(--trae-accent-cyan)',
  cyan: 'var(--trae-accent-cyan)',
  success: 'color-mix(in srgb, var(--trae-accent) 30%, #22c55e)',
  text: 'var(--trae-text)',
  textSoft: 'var(--trae-text-soft)',
  textMuted: 'var(--trae-text-muted)',
  border: 'var(--trae-border)',
  surface: 'var(--trae-surface)',
  surfaceStrong: 'var(--trae-surface-strong)',
  danger: 'color-mix(in srgb, var(--trae-accent-strong) 35%, #ef4444)',
  warning: 'color-mix(in srgb, var(--trae-accent) 35%, #f59e0b)',
  series: [
    'var(--trae-accent)',
    'var(--trae-accent-strong)',
    'var(--trae-accent-cyan)',
    'color-mix(in srgb, var(--trae-accent) 30%, #f59e0b)',
    'color-mix(in srgb, var(--trae-accent) 30%, #22c55e)',
    'color-mix(in srgb, var(--trae-accent-strong) 30%, #ef4444)'
  ],
  zone: {
    UNASSIGNED: 'var(--trae-accent)',
    appointmentCompleted: 'var(--trae-accent)',
    walkInCompleted: 'var(--trae-accent-cyan)'
  }
};

/**
 * Default pie segment colors.
 */
export const PIE_COLORS = [
  CHART_COLORS.accent,
  CHART_COLORS.danger,
  CHART_COLORS.warning,
  CHART_COLORS.accentStrong,
  CHART_COLORS.accentCyan,
  CHART_COLORS.textMuted
];
